// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"23359343","647":"e2255ea6"}[chunkId] + ".chunk.css";
};